
import axios from "axios";

const BASE_URL = "https://strengthshadow.com/api.php";

/** API Class.
 *
 * Static class tying together methods used to get/send to the API.
 * There shouldn't be any frontend-specific stuff here, and there shouldn't
 * be any API-aware stuff elsewhere in the frontend.
 *
 */

class WorkoutApi {
  // the token for interacting with the API will be stored here.
  static token;

  static async request(endpoint, data = {}, method = "get") {
    console.debug("API Call:", endpoint, data, method);

    // Building the URL for the request
    const url = `${BASE_URL}?endpoint=api/${endpoint}`;

    const headers = { Authorization: `Bearer ${WorkoutApi.token}` };

    const params = method === "get" ? data : {};

    try {
      console.log(url, method, data, params, headers);
      return (await axios({ url, method, data, params, headers })).data;
    } catch (err) {
      console.error("API Error:", err.response);
      let message = err.response.data.error.message;
      throw Array.isArray(message) ? message : [message];
    }
  }

  // Individual API routes

  /** Get details on a company by handle. */
  static async getCompany(handle) {
    let res = await this.request(`companies/${handle}`);
    return res.company;
  }

  static async getCompanySearch(name) {
    let res = await this.request(`companies/?name=${name}`);
    return res;
  }

  static async registerUsers(data) {
    console.log(data);
    let res = await this.request(`users/signup`, data, "post");
    console.log("register");
    console.log("res", res);
    this.token = res.token;  // Assuming the token is returned here
    console.log("token", this.token);
    return res;
  }

  static async authenticateUsers(fdata) {
    console.log(fdata);
    let res = await this.request(`auth/token`, { ...fdata }, "post");
    console.log("THIS IS THE RESULT", res);
    return res;
  }

  static async getUserName(username) {
    const lowerUsername = username.toLowerCase();
    console.log(lowerUsername);
    let res = await this.request(`users/${lowerUsername}`);
    console.log(res);
    return res.user;
  }

  static async getUserId(user_id) {
    let res = await this.request(`users/${user_id}`);
    console.log(res);
    return res.user;
  }

  static async getExercise(exercise_id) {
    let res = await this.request(`exercise/${exercise_id}/edit`);
    console.log(res.exercise);
    return res.exercise;
  }

  static async getWorkout(user_id, id) {
    let res = await this.request(`workouts/${user_id}/id/${id}`);
    console.log(res.workouts);
    return res.workouts;
  }

  static async getWorkoutExercises(user_id, id) {
    let res = await this.request(`exercise/${user_id}/id/${id}`);
    return res.workouts;
  }

  static async getWorkouts(user_id) {
    let res = await this.request(`workouts/${user_id}`);
    console.log(res);
    return res.workouts;
  }

  static async getSets(exercise_id) {
    let res = await this.request(`set/${exercise_id}`);
    console.log(res);
    return res.set;
  }

  static async createWorkout(data) {
    console.log(data);
    let res = await this.request(`workouts/create`, { ...data }, "post");
    return res;
  }

  static async createExercise(user_id, workout_id, data) {
    console.log("API", data);
    let res = await this.request(
      `exercise/user/${user_id}/workout/${workout_id}`,
      { ...data },
      "post"
    );
    return res.exercise;
  }

  static async createSet(exercise_id, data) {
    console.log("API", data);
    let res = await this.request(
      `exercise/${exercise_id}`,
      { ...data },
      "post"
    );
    return res.set;
  }

  static async deleteUsers(username) {
    const lowerUsername = username.toLowerCase();
    let res = await this.request(`users/${lowerUsername}`, {}, "delete");
    return res.user;
  }

  static async deleteExercise(exercise_id) {
    let res = await this.request(
      `exercise/${exercise_id}/delete`,
      {},
      "delete"
    );
    return res.exercise;
  }

  static async deleteSets(exercise_id, set_id) {
    let res = await this.request(
      `set/${exercise_id}/${set_id}/delete`,
      {},
      "delete"
    );
    return res.sets;
  }

  static async patchUser(username, data) {
    console.log(data);
    let res = await this.request(`users/${username}`, { ...data }, "patch");
    console.log("new res", res.user);
    return res.user;
  }

  static async patchWorkout(user_id, id, data) {
    let res = await this.request(
      `workouts/${user_id}/id/${id}`,
      { ...data },
      "patch"
    );
    console.log("new res", res);
    return res.workout;
  }

  static async patchExercise(exercise_id, data) {
    let res = await this.request(
      `exercise/${exercise_id}/edit`,
      { ...data },
      "patch"
    );
    console.log("new res", res);
    return res.exercise;
  }

  static async deleteWorkout(user_id, id) {
    console.log(user_id, id);
    let res = await this.request(`workouts/${user_id}/id/${id}`, {}, "delete");
    return res.workout;
  }
}

export default WorkoutApi;